// Halogens: Cl, F, Br, I, As, Ts
// Sarah and Joe: NAT-121 As and Ts shouldn't be used in organic chemistry.
// export const halogen_elements = ["As", "Br", "Cl", "F", "I", "Ts"]
export const halogen_elements = ["Br", "Cl", "F", "I"]
